// extracted by mini-css-extract-plugin
export default {"cms-title":"cms_cms-title__reB6X"};